module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/dXT7eR/images/e9781439619438_cover.jpg?1684229397636",
      "alt": "This image is the cover for the book Angel Flight Mid-Atlantic, Images of Aviation"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Angel Flight Mid-Atlantic, Images of Aviation\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("In 1972, two pilots�one a federal career engineer, the other the pastor of a prominent church in Washington, D.C.�discovered a common passion for flying airplanes and serving people. One day over lunch, the men conceived a flight plan, one that would undergo many changes before becoming Angel Flight Mid-Atlantic, as it is known today. Ed Boyer of the U.S. Department of Health and Human Services and Dr. Louis Evans, pastor of the National Presbyterian Church, discussed how to pool their interests and qualifications. From its beginnings as a charitable shuttle service for religious leaders and dignitaries, to full-scale charitable air ambulance operations, to Angel Flights for ambulatory patients, the initial vision has grown into a network of over 1,500 volunteer pilots in the Mid-Atlantic region who use their private planes to fly people in need to specialized treatment. Angel Flight coordinates missions of mercy from its offices in Virginia Beach, helping patients to find �the shortest distance between home and hope.�")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Suzanne Rhodes\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("The story of this remarkable air charity is captured through images of pilots, planes, and patients collected by public affairs director Suzanne Rhodes. A resident of Virginia Beach, Rhodes is an adjunct college professor and the author of five books.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Arcadia Publishing\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0